// ── A public visit, in pure functions ─────────────────────────────────────────
//
// Nothing here touches the DOM, storage or the API: it is the arithmetic of a
// half-hour visit, kept apart so it can be tested without a browser. session.js
// and the band use it.

/** Where the visit is remembered across a reload. */
export const VISIT_KEY = 'general.demo.visit'

/** The minutes left at which the band starts warning. */
export const WARN_MINUTES = 5

/** `?ticket=`, the one-use code the front page sends the visitor with. */
export function requestedTicket(search) {
  const value = new URLSearchParams(search).get('ticket')
  return value && /^[A-Za-z0-9_-]{20,100}$/.test(value) ? value : null
}

/**
 * Whole minutes left, rounded UP: with forty seconds to go the band says 1,
 * never 0 — 0 is the moment the visit ends.
 */
export function minutesLeft(endsAt, now = Date.now()) {
  const end = new Date(endsAt ?? NaN).getTime()
  if (!Number.isFinite(end)) return null
  return Math.max(0, Math.ceil((end - now) / 60_000))
}

/** True once the visit's end has passed. */
export function visitOver(endsAt, now = Date.now()) {
  const end = new Date(endsAt ?? NaN).getTime()
  return Number.isFinite(end) && end <= now
}

/**
 * Which module a route belongs to, for the telemetry: the module of the
 * permission it asks for (`crm:read` → crm), or else the first segment of its
 * path. Null for the shell's own screens.
 */
export function moduleOfRoute(route) {
  const permission = [].concat(route?.meta?.permission ?? [])[0]
  if (typeof permission === 'string' && permission.includes(':')) return permission.split(':')[0]
  const first = String(route?.path ?? '').split('/').filter(Boolean)[0]
  if (!first || ['demo', 'login', 'help', 'profile', 'settings'].includes(first)) return null
  return /^[a-z0-9-]+$/.test(first) ? first : null
}

/** The address without `ticket`, so a reload or a copied link carries nothing. */
export function withoutTicket(href) {
  const url = new URL(href)
  url.searchParams.delete('ticket')
  return `${url.pathname}${url.search}${url.hash}`
}

/** The front page itself, from the exit address: same place, no query. */
export function frontPage(exitUrl) {
  if (!exitUrl) return ''
  try {
    const url = new URL(exitUrl)
    return `${url.origin}${url.pathname}`
  } catch {
    return ''
  }
}
